export default __webpack_public_path__ + "static/media/imitation-game.1db794ce.jpg";